<template>
  <div class="menucontrol-scroll fixed-top">
    <Banner />

    <ResouceIframe />
  </div>
</template>
<script>
import { mapState } from "vuex";
import Banner from "./components/Banner.vue";
import ResouceIframe from "./components/ResouceIframe.vue";
import AutoLogin from "./components/autoLogn.vue";

export default {
  components: {
    Banner,
    ResouceIframe,
    AutoLogin,
  },
};
</script>
